import { queryClient } from "./useQuery"

export default {
  clear() {
    void queryClient.invalidateQueries()
  },
  invalidate(queryKey: string[]) {
    void queryClient.invalidateQueries({ queryKey })
  },
}
